import { Transform, TransformFnParams, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { toEuros } from "@/utils/numberUtils";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { PayrollLineDto } from "@/core/features/payrolls/payroll-line.dto";
import { PayrollStatusEnum } from "@/core/features/payrolls/payroll-status.enum";

const transformToEuros = ({ value }: TransformFnParams): number => toEuros(value as number);

export class PayrollDto extends BaseEntityDto {
  @Type(() => UserDto)
  user?: UserDto;

  userId: string;

  @Transform(({ value }) => parseApiDate(value))
  payrollDate: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  deadlineDate?: Date | null;

  @Transform(transformToEuros)
  totalAmount: number;

  status: PayrollStatusEnum;

  notes?: string;

  @Type(() => PayrollLineDto)
  lines?: PayrollLineDto[];
}
